<template>
    <v-card color="kbWhite">
        <v-dialog @input="toggleDeleteFieldDialog"
                  max-width="700px"
                  v-model="deleteCustomExtradata">
            <v-card color="kbRed">
                <v-toolbar class="text-h6" color="kbSemiLightGray" dark dense flat>
                    <span>
                      {{$t('general.deleteInfoField')}}
                    </span>
                    <v-spacer/>
                    <v-btn @click="toggleDeleteFieldDialog(false)"
                           icon>
                        <v-icon>
                            clear
                        </v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                          <span class="d-block white--text">
                            {{$t('general.deleteAllDataForEveryOne')}}
                          </span>

                          <span class="white--text">
                            {{$t('general.justHideTheField')}}
                          </span>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn @click="toggleDeleteFieldDialog(false)"
                           color="white"
                           outlined>
                        {{$t('general.cancel')}}
                    </v-btn>

                    <v-btn @click="deleteFieldRequest(false)"
                           class="mx-2"
                           color="white"
                           outlined
                           :loading="deleting">
                      {{$t('general.hideTheField')}}
                    </v-btn>

                    <v-btn @click="deleteFieldRequest(true)"
                           class="ml-0"
                           color="kbSemiLightGray"
                           dark>
                      {{$t('general.clearDataOfAllPeople')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ExtradataCreator @clear="selectedField = null"
                          :selectedField="selectedField"
                          v-model="showExtradataCreatorDialog">
        </ExtradataCreator>

        <v-card-title class="text-h6 kbDarkBlueText--text">
            {{ $t('general.extraManagementAditionalInfo') }}
        </v-card-title>

        <v-card-text>
            <v-row>
                <v-col cols="12" v-if="appCustomExtradatas.length === 0">
                    <v-icon class="mr-2" color="info">
                        mdi-information-outline
                    </v-icon>
                    {{$t('general.sectionAddInfoPeopleOfBrandRequested')}}
                </v-col>

                <v-col cols="12">
                    <v-list two-line color="kbWhite">
                        <v-list-item :key="index"
                                     v-for="(item, index) in appCustomExtradatas">
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon style="cursor: pointer" v-on="on">
                                            {{item.access === 'app' ? 'apps' : 'person'}}
                                        </v-icon>
                                    </template>

                                    <span>
                                        {{
                                        item.access === 'app'
                                        ? $t('general.extraManagementItemAccessApplication')
                                        : $t('general.extraManagementItemAccessPerson')}}
                                    </span>
                                </v-tooltip>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title>
                                    {{item.name}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ subtitle(item) }}
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <div>
                                    <v-btn @click="updateField(item)"
                                           color="kbDarkBlueText"
                                           text
                                           icon>
                                        <v-icon>
                                            edit
                                        </v-icon>
                                    </v-btn>

                                    <v-btn class="ml-2"
                                           @click="deleteField(item)"
                                           color="error"
                                           text
                                           icon>
                                        <v-icon>
                                            delete
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-col>

                <v-expand-transition v-if="!newExtradata">
                    <v-col class="text-right" cols="12" >
                        <v-btn @click="createField()"
                               color="kbLightBlue"
                               dark
                               rounded>
                            <v-icon left>
                                add
                            </v-icon>
                            {{ $t('general.extraManagementAddNewField') }}
                        </v-btn>
                    </v-col>
                </v-expand-transition>

                <v-expand-transition>
                    <v-col cols="12" v-if="newExtradata">
                        <v-form lazy-validation
                                ref="newExtradataForm"
                                @submit.prevent>
                            <v-text-field @keypress.enter="addExtradata()"
                                          :label="$t('general.enterExtraDataId')"
                                          v-model="extradata">
                                <template #append>
                                    <v-btn @click="addExtradata()"
                                           color="kbDarkBlueText"
                                           icon
                                           :loading="addingExtradata"
                                           small>
                                        <v-icon>
                                            check
                                        </v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-form>
                    </v-col>
                </v-expand-transition>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import ExtradataCreator from '@/pages/App/AppsDetails/ExtradataCreatorDialog.vue'
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  components: { ExtradataCreator },
  computed: {
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas,
      tags: state => state.apps.tags
    })
  },
  created () {
    this.$store.dispatch('getAppCustomExtradatas')
    this.$store.dispatch('getAppTagsOfCustomExtraData')
  },
  data: () => ({
    addingExtradata: false,
    deleteCustomExtradata: '',
    deleting: false,
    extradata: '',
    extradatas: [],
    newExtradata: false,
    showExtradataCreatorDialog: false,
    selectedField: null,
    selectedFieldToDelete: null
  }),
  methods: {
    createField () {
      this.showExtradataCreatorDialog = true
    },
    deleteField (edField) {
      this.selectedFieldToDelete = edField
      this.deleteCustomExtradata = true
    },
    async deleteFieldRequest (deleteFromAllUsers) {
      try {
        this.selectedFieldToDelete.deleteFromAllUsers = deleteFromAllUsers || false
        this.deleting = true
        await this.$store.dispatch('deleteCustomExtradata', this.selectedFieldToDelete)
        await this.$store.dispatch('getAppCustomExtradatas')
        notifications.success(this.$t('general.fieldSuccessfullyDeleted'))
        this.selectedFieldToDelete = ''
        this.deleteCustomExtradata = false
        this.deleting = false
      } catch (e) {
        notifications.error(e)
        this.deleting = false
      }
    },
    subtitle (item) {
      if (item.type === 'text') return this.$t('general.extraCreatorShortText')
      if (item.type === 'select') return this.$t('general.extraCreatorList')
      if (item.type === 'radio') return this.$t('general.extraCreatorRadioList')
      if (item.type === 'checkbox') return this.$t('general.extraCreatorCheckList')
      if (item.type === 'textLong') return this.$t('general.extraCreatorLongText')
      if (item.type === 'numeric') return this.$t('general.numeric')
      if (item.type === 'email') return this.$t('general.extraCreatorEmail')
      if (item.type === 'money') return this.$t('general.money')
      if (item.type === 'phone') return this.$t('general.phone')
      if (item.type === 'date') return this.$t('general.date')
      if (item.type === 'dateTime') return this.$t('general.datetime')
      return null
    },
    toggleDeleteFieldDialog (value) {
      if (!value) {
        this.selectedFieldToDelete = ''
        this.deleteCustomExtradata = false
      }
    },
    updateField (field) {
      this.selectedField = field
      this.showExtradataCreatorDialog = true
    }
  }
}
</script>
